import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { formatEur } from '../../lib/format';
import { t } from '../../i18n/pt';

interface SalesChartProps {
  days: string[];
  thisWeek: number[];
  lastWeek: number[];
}

const THIS_WEEK = '#c07d80'; // admin-accent (rose)
const LAST_WEEK = '#d9b8bb'; // muted rose

export function SalesChart({ days, thisWeek, lastWeek }: SalesChartProps): JSX.Element {
  const data = days.map((day, i) => ({
    day,
    esta: thisWeek[i] ?? 0,
    passada: lastWeek[i] ?? 0,
  }));

  return (
    <>
      <div className="mb-2 flex items-center justify-end gap-4 text-xs text-admin-text-soft">
        <span className="inline-flex items-center gap-1.5">
          <span className="h-2 w-2 rounded-full" style={{ background: THIS_WEEK }} />
          {t.admin.sections.thisWeek}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <span className="h-2 w-2 rounded-full" style={{ background: LAST_WEEK }} />
          {t.admin.sections.lastWeek}
        </span>
      </div>
      <div className="h-[220px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 8, right: 8, bottom: 0, left: -16 }}>
            <CartesianGrid vertical={false} stroke="#ead6d3" />
            <XAxis
              dataKey="day"
              tickLine={false}
              axisLine={false}
              tick={{ fill: '#a0808a', fontSize: 12 }}
            />
            <YAxis
              tickLine={false}
              axisLine={false}
              tick={{ fill: '#a0808a', fontSize: 12 }}
              width={48}
            />
            <Tooltip
              formatter={(value) => formatEur(Number(value))}
              contentStyle={{
                borderRadius: 8,
                border: '1px solid #ead6d3',
                fontSize: 12,
              }}
            />
            <Line
              type="monotone"
              dataKey="passada"
              name={t.admin.sections.lastWeek}
              stroke={LAST_WEEK}
              strokeWidth={2}
              dot={false}
            />
            <Line
              type="monotone"
              dataKey="esta"
              name={t.admin.sections.thisWeek}
              stroke={THIS_WEEK}
              strokeWidth={2.5}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </>
  );
}
